export default {
  state: {
    links: {
      organization: [
        {
          name: "Profile",
          link: "org.settings.profile",
          permission: "profile",
        },
        {
          name: "Users",
          link: "org.settings.profile.users",
          permission: "users",
        },
        {
          name: "Role Management",
          link: "org.settings.profile.roles",
          permission: "roles",
        },
        {
          name: "SSO",
          link: "org.settings.profile.sso",
          permission: "s_s_o",
        },
        {
          name: "Organization Domains",
          link: "org.settings.profile.domains",
          permission: "domains",
        },
        /* {
          name: "Subscription",
          link: "org.settings.profile.subscription",
          permission: "subscriptions",
        },
        {
          name: "Payment & Invoices",
          link: "org.settings.profile.payment",
          permission: "subscriptions",
        }, */
      ],
      teams: [
        {
          name: "Teams",
          link: "org.settings.teams",
          permission: "teams",
        },
        {
          name: "Members",
          link: "org.settings.teams.members",
          permission: "members",
        },
        {
          name: "Team Domains",
          link: "org.settings.teams.domains",
          permission: "domains",
        },
        {
          name: "API Tokens",
          link: "org.settings.teams.api",
          permission: "supervisor",
        },
      ],
    },
  },

  getters: {
    canAccessPersonalWorkspace: (state, getters) => {
      return (
        getters.isOrgOwner ||
        getters.isOrgUser ||
        getters.isTeamAdminInAnyTeam ||
        getters.isTeamMemberInAnyTeam
      );
    },

    isOrgOwner: (state, getters) => {
      return (
        getters.organization?.owner === true ||
        getters.organization?.owner?.email === getters.user.email
      );
    },
    isOrgUser: (state, getters) => {
      return getters.organization?.role ? true : false;
    },
    isOrgMember: (state, getters) => {
      return (
        getters.isTeamAdminInAnyTeam ||
        getters.isTeamMemberInAnyTeam ||
        getters.isTeamViewerInAnyTeam
      );
    },

    isTeamAdminInAnyTeam: (state, getters) => {
      const result = getters.organizationTeams?.find(
        (t) => t.membership?.role == "admin",
      );

      return result ? true : false;
    },
    isTeamMemberInAnyTeam: (state, getters) => {
      const result = getters.organizationTeams?.find(
        (t) => t.membership?.role == "member",
      );

      return result ? true : false;
    },
    isTeamViewerInAnyTeam: (state, getters) => {
      const result = getters.organizationTeams?.find(
        (t) => t.membership?.role == "viewer",
      );

      return result ? true : false;
    },

    isTeamAdminInCurrentTeam: (state, getters) => {
      return getters.organizationTeam?.membership?.role == "admin";
    },
    isTeamMemberInCurrentTeam: (state, getters) => {
      return getters.organizationTeam?.membership?.role == "member";
    },
    isTeamViewerInCurrentTeam: (state, getters) => {
      return getters.organizationTeam?.membership?.role == "viewer";
    },

    shouldShowOrgSettings: (state, getters) => {
      if (getters.isOrgUser && getters.settingOrganizationLinks.length) {
        return true;
      } else {
        return getters.isOrgOwner;
      }
    },
    settingOrganizationLinks: (state, getters) => {
      let menus = state.links.organization;

      if (getters.isOrgOwner) {
        menus = menus;
      } else if (getters.isOrgUser) {
        menus = menus.filter((m) => {
          const permissions = getters.organization.role.permissions;
          return permissions.some((p) => p.name == m.permission);
        });
      } else {
        menus = [];
      }

      return menus;
    },

    shouldShowTeamSettings: (state, getters) => {
      if (getters.isOrgOwner) {
        return true;
      } else {
        if (getters.isOrgUser && getters.settingTeamsLinks.length) {
          return true;
        } else {
          return getters.isTeamAdminInAnyTeam;
        }
      }
    },
    settingTeamsLinks: (state, getters) => {
      let menus = state.links.teams;

      if (getters.isOrgOwner || getters.isTeamAdminInAnyTeam) {
        menus = menus;
      } else if (getters.isOrgUser) {
        menus = menus.filter((m) => {
          const permissions = getters.organization.role.permissions;
          const exists = permissions.find((p) => p.name == m.permission);

          return exists ? true : false;
        });
      } else {
        menus = [];
      }

      return menus;
    },
  },
};
